<template>
    <el-dialog v-bind="$attrs"
               v-on="$listeners"
               title="流程跟踪"
               append-to-body
			    :close-on-click-modal="false"
               width="95%" class="showflowDialogcls">
        <div class="h-content paddingtopcls">
            <div class="h-row" style="background: #fff;margin-left: 0rem; margin-right: 0rem;">
                <div class="h-rowIn" style="width: 100%;">
                    <div style="width: 100%">
                        <img src="../../assets/images/flow/shili.png" style="width: 100%;"/>
                    </div>
                    <div id="graphContainer"
                         ref="graphContainer">

                    </div>
                </div>

                <div    v-if="showTaskList"
                     class="showTaskListClass"
                     :style="{
                              top:showTaskListPosition.top,
                              left:showTaskListPosition.left
                              }">
                    <table>
                        <thead>
                            <tr>
                                <th width="80px">待办人</th>
                                <th width="110px">开始时间</th>
                                <th width="110px">结束时间</th>
                                <th width="110px">操作</th>
                                <th width="60px">状态</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in nodetasklist">
                                <td>{{item.dbrname}}</td>
                                <td>{{item.begindate}}</td>
                                <td>{{item.enddate}}</td>
                                <td>{{item.shpopt}}</td>
                                <td>{{item.status|taskstatus}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="h-row h-mrt0" style="background: #fff;margin-left: 0rem; margin-right: 0rem;">
                    <div class="h-rowIn">
                        <div class="h-rowBox">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>流程审批历史</h1>
                                    </div>
                                    <div class="outTimeline">
                                        <el-timeline>
                                            <el-timeline-item  v-for="o1,i1 in hislist" v-if="o1.nodetype == '20' || o1.nodetype == '30'" :timestamp="o1.name" placement="top" color='#2589f3'>
                                                <div v-if="showBlflag(o1,1)" class="timeTip">*须全部人员审批</div>
                                                <div v-else-if="showBlflag(o1,2)" class="timeTip">*至少一个人审批</div>

                                                <el-card v-for="o,i in o1.tasklist" class="box-card"  style="margin-bottom: 0.15rem;">
                                                    <div class="eve_half">
                                                        <span>经办时间：</span><span>{{o.begindate}}</span>
                                                    </div>
                                                    <div class="eve_half">
                                                        <span>办理时间：</span>
                                                        <span v-if="o.status==0" class="corlorOrange">未办理</span>
                                                        <span v-else>{{o.enddate}}</span>
                                                    </div>
                                                    <div class="eve_half">
                                                        <span>经办人：</span><span>{{o.dbrname}}[{{o.dbrcode}}]</span>
                                                    </div>
                                                    <div class="eve_half">
                                                        <span>审批操作：</span><span>{{o.shpopt}}</span>
                                                    </div>
                                                    <div class="eve_all">
                                                        <span>审批意见：</span><span>{{o.shpyj}}</span>
                                                    </div>
                                                    <el-button @click="cuibanBtnclick(o)" v-if="showCuiban(o)" class="h-btn h-formBtn h-mr20 cuban btnColor">
                                                        催办
                                                    </el-button>
                                                </el-card>

                                            </el-timeline-item>

                                        </el-timeline>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>




        <el-dialog  :close-on-click-modal="false" title="邮件催办" append-to-body :visible.sync="youjianCuibanShow">

            <el-form :model="form" label-width="120px">
                <el-form-item label="收件人工号" >
                    <el-input v-model="form.usercode" readonly auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="收件人姓名" >
                    <el-input v-model="form.username" readonly auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="收件人电话" >
                    <el-input v-model="form.phone" readonly auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="收件人邮箱" >
                    <el-input v-model="form.email" auto-complete="off"></el-input>
                    <span style="color:red;">收件人邮箱信息为空或不对的话，请手动维护</span>
                </el-form-item>
                <el-form-item label="催办内容"  >
                    <el-input
                            type="textarea"
                            :rows="5"
                            placeholder="请输入内容"
                            v-model="form.sendEmail">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="fasongYoujian">发送邮件</el-button>
            </div>
        </el-dialog>

    </el-dialog>
</template>

<script>
    import ss from '../../api/SystemService'
    import {genGraph} from '@/views/process/graph/Graph';

    import mxgraph from '@/views/process/graph/index';

    const {
        mxCellMarker,
        mxCellTracker,
        mxUtils,
        mxRectangle,
        mxEvent,
        mxWindow,
        mxConstants,
    } = mxgraph;


    // [mxConstants.STYLE_ROUNDED]: true,
    //     [mxConstants.STYLE_STROKECOLOR]: '#C3D9FF',
    //     [mxConstants.STYLE_FONTCOLOR]: '#333333',
    //     [mxConstants.STYLE_FILLCOLOR]: '#C3D9FF',
    //     [mxConstants.STYLE_SHADOW]: '1',
    //     [mxConstants.STYLE_GRADIENTCOLOR]: 'white',

    function setStyle(state, status)
    {
        if (status){
            state.style[mxConstants.STYLE_FILLCOLOR] = '#69be6b';
        }else{
            state.style[mxConstants.STYLE_FILLCOLOR] = '#fcb342';
        }
        state.shape.apply(state);
        state.shape.redraw();
    };
    export default {
        props:["id"],
        filters: {
            taskstatus: function (value) {
                return value==1?"已完成":"未处理"
            }
        },
        data() {
            return {
                showTaskList:false,
                showTaskListPosition:{
                    top: '0',
                    left: '0',},
                nodetasklist:[],
                graph:null,
                taskid: null,
                hislist: [],
                inst: {},

            //  展示审批流
                tabIndex: 1,
                hislist:[],
                hismm:[],
                userhislist:[],
            //
                youjianCuibanShow:false,
                form: {
                    taskid:null,
                    usercode:null,
                    username:null,
                    email:null,
                    sendEmail:null,
                },
                tuibantask:null,
            };
        },
        computed: {
            instid:function () {
                return this.id
            },

        },
        mounted() {
            this.init();
            // this.loadlist();
        },
        methods: {
            init() {
                if(this.instid){
                    ss.proinstservice.getByid(this.instid).then(rd => {
                        this.inst = rd.obj;
                        ss.prodefservice.selectById(this.inst.defid).then(rd => {
                            var result = rd;
                            ss.taskservice.listHistoryByInstid(this.instid).then(rd => {
                                this.hislist = rd.history;
                                this.reshowFlow(result);
                            })
                        })
                    })
                }
            },
            cuibanBtnclick(o){
                this.tuibantask = o;
                console.log(o,"oooo")
                this.youjianCuibanShow = true;
                //订单催办获取售达方信息
                if(o.ywid){
                  ss.UserService.getOrderAgent(o.ywid).then(rd=>{
                    console.log(rd)
                    this.form.agentEmail = rd.msg.email;
                    this.form.agentName = rd.msg.customerName1;
                    this.form.agentCode = rd.msg.usercode;
                  })
                }
                ss.UserService.selectById(o.dbrcode).then(rd=>{
                    _.assign(this.form,rd.obj)
                })
            },
            showCuiban (v) {
                if(v.status == '0' && v.cjrcode == this._user.usercode){
                    return true;
                }
                return false;
            },
            fasongYoujian(){
                var sendobj = _.assign({},this.form);
                if(sendobj.agentEmail != null && sendobj.agentEmail != ''){
                  sendobj.sendEmail = sendobj.sendEmail +",售达方名称:"+sendobj.agentName+",售达方编码:"+sendobj.agentCode+",售达方邮箱:" +sendobj.agentEmail+ "      系统待办备注："+ this.tuibantask.beizhu.replace("[", "").replace("]", "");
                }else {
                  sendobj.sendEmail = sendobj.sendEmail +"      系统待办备注："+ this.tuibantask.beizhu.replace("[", "").replace("]", "");
                }
                ss.UserService.sendEmailToUser(sendobj).then(rd=>{
                    this.$msg.msgs('发送成功！')
                    this.youjianCuibanShow = false;
                })
            },
            reshowFlow(rd){
                const container = this.$refs.graphContainer
                this.graph = genGraph(container)
                this.graph.importModelXML(rd.obj.prodefxml);
                this.graph.setEnabled(false);
                //设置导航图的任务节点的鼠标与移入移出效果
                new mxCellTracker(this.graph,"#6482b9");
                var vm  = this;
                var vmgraph = this.graph;
                this.graph.addMouseListener({
                    mouseMove(sender,me){
                        var cell = me.getCell()
                        if(cell && vmgraph.getModel().isVertex(cell) && cell.flag==20){
                            vm.showTaskListPosition.left = me.evt.x + 'px';
                            vm.showTaskListPosition.top = me.evt.y + 'px';
                            this.nodetasklist = [];
                            var rt = vm.setTaskLsit(cell.id)
                            vm.showTaskList = rt;
                        }else{
                            this.nodetasklist = [];
                            vm.showTaskList = false;
                            return ;
                        }
                    },
                })

                var allcells = this.graph.getModel().cells;
                // console.log(allcells)
                //开始节点// 结束节点
                for(var i in allcells){
                    var se = allcells[i];
                    if(se.flag==10){
                        setStyle(this.graph.view.getState(se),1);
                    }else if(se.flag==100){
                        if(this.inst.status == '已结束'){
                            setStyle(this.graph.view.getState(se),1);
                        }
                    }
                }
                //根据所有的task，设置node的border的style
                var donetask = _.filter(this.hislist,{status:1});
                var undonetask = _.filter(this.hislist,{status:0});
                for(var i=0;i<donetask.length;i++){
                    var obj = donetask[i];
                    var cell = allcells[obj.nodeid];
                    setStyle(this.graph.view.getState(cell),obj.status)
                }
                for(var i=0;i<undonetask.length;i++){
                    var obj = undonetask[i];
                    var cell = allcells[obj.nodeid];
                    setStyle(this.graph.view.getState(cell),obj.status)
                }

            },
            //根据id，获取task数据
            setTaskLsit(id){
                var list = _.find(this.hislist,{nodeid:id});
                if(list && list.tasklist){
                    this.nodetasklist = list.tasklist
                    return true;
                }
                return false;
            },

            showBlflag(o,f){
                if(o.tasklist && o.tasklist.length<=1){
                    return false;
                }
                if(o.status==0 && o.binglianflag == f){
                    return true;
                }
                return false;
            },
            tabchange(i) {
                this.tabIndex = i;
            },
            loadlist(){
                ss.taskservice.listHistoryByInstid(this.instid).then(rd => {
                    this.hislist = rd.history;
                })
            }
        }
    }
</script>
<style>
    .showflowDialogcls .el-dialog__body{
        padding-top: 0px!important;
    }
</style>
<style scoped>
    #graphContainer {
        overflow: hidden;
        width: 100%;
        min-height: 150px;
        padding-bottom: 20px;
        background: url('../../assets/images/flow/grid.gif');;
        border-radius: 4px;
    }
    .h-content {
        padding: 0rem 0.1rem 0 0.1rem;
    }
    .h-row .h-rowIn {
      padding: 0px !important;
    }
    .showTaskListClass {
        width:400px;
        border:1px solid #ccc;
        position: fixed;
        color:#333;
        font-size: 12px;
        z-index: 9999;
        background-color: rgba(255,255,255,0.8);
        border: 1px solid #c2c2c2;
        border-radius: 5px;
        padding: 12px;
    }
    .showTaskListClass  table {
          border-collapse: collapse;
          margin: 0 auto;
          text-align: center;
      }
    .showTaskListClass  table thead th{
        background-color: #57aefe;
        text-align: center;
        color:#fff;
    }
    .showTaskListClass table td, table th
    {
        border: 1px solid #cad9ea;
        color: #666;
        height: 30px;
    }
    .showTaskListClass table tr:nth-child(odd)
    {
        background: #fff;
    }
    .showTaskListClass table tr:nth-child(even)
    {
        background: #F5FAFA;
    }
    .outTimeline {
        background-color: #fcfcfc;
        border-radius: 10px;
    }
    .timeTip{
        font-size: 12px;
        color:#ff0000;
    }

    .box-card {
        color: #494949;
        position: relative;
    }
    .eve_half {
        width: 50%;
        float: left;
    }

    .eve_all {
        width: 100%;
    }

    .corlorOrange {
        color: #e64a19;
    }
    .cuban{
        position: absolute;
        right: 10px;
        top: 10px;
    }
</style>

